/** PL translations for Les Aiguilles Blanches */
const pl: Record<string, string> = {
  subtitle: "Symulator ratraka",
  startGame: "Rozpocznij grę",
  resumeGame: "Wznów",
  newGame: "Nowa gra",
  // UNUSED continue: "Kontynuuj",
  settings: "Ustawienia",
  controls: "Sterowanie",
  changelog: "Nowości",
  howToPlay: "Jak grać",
  fullscreen: "Pełny ekran",
  fullscreenHint: "Naciśnij F aby włączyć pełny ekran",
  exitFullscreen: "Wyłącz pełny ekran",
  back: "Wstecz",
  backToGame: "Wróć do gry",
  // UNUSED loading: "Ładowanie...",
  inputKeyboard: "✓ Klawiatura wykryta",
  inputKeyboardOff: "✗ Brak klawiatury",
  inputTouch: "✓ Ekran dotykowy wykryty",
  inputTouchOff: "✗ Nie wykryto ekranu dotykowego",
  inputGamepad: "✓ Gamepad podłączony",
  inputGamepadOff: "✗ Brak gamepada",
  updateAvailable: "Nowa wersja dostępna — dotknij, aby odświeżyć",
  madeIn: "Zrobione z ❄️ w Sabaudii",
  feedback: "Prześlij opinię",
  on: "✓ WŁ",
  off: "✗ WYŁ",
  zoneClosed: "🚫 STREFA ZAMKNIĘTA",

  // Settings
  language: "Język",
  accessibility: "Dostępność",
  highContrast: "Wysoki kontrast",
  reducedMotion: "Ograniczony ruch",
  showFps: "Pokaż FPS",
  showDebug: "Nakładka debugowania",
  skiStyle: "Styl",
  skiTricks: "Triki",
  skiBestCombo: "Najlepsze combo",
  quitGame: "Wyjdź z gry",
  display: "Wyświetlanie",
  displayWindowed: "Okno",
  displayFullscreen: "Pełny ekran",
  displayBorderless: "Bez ramki",
  colorblindMode: "Daltonizm",
  none: "Brak",
  deuteranopia: "Deutan.",
  protanopia: "Protan.",
  tritanopia: "Tritan.",
  // UNUSED move: "Ruch",
  moveUp: "Góra",
  moveDown: "Dół",
  moveLeft: "Lewo",
  moveRight: "Prawo",
  groom: "Ratrakować",
  winch: "Wciągarka",
  pause: "Pauza",
  keyboard: "Klawiatura",
  clickToRebind: "Kliknij aby zmienić",
  pressKey: "Naciśnij klawisz...",
  pressGamepadButton: "Naciśnij przycisk gamepada...",
  noGamepad: "Brak podłączonego pada",
  gamepadButtons: "Gamepad",
  saved: "Zapisano!",
  resetControls: "Resetuj wszystko",
  controlsReset: "Sterowanie zresetowane!",
  movementSensitivity: "Czułość",
  keyboardLayout: "Układ",
  customBindings: "Własne",
  // UNUSED gamepadSupported: "Gamepad OK",
  touch: "Dotyk",
  // UNUSED touchSupported: "Dotyk OK",
  noGamepadConnected: "Brak podłączonego gamepada",
  gamepadDiagnostic: "Test kontrolera",
  connectGamepadDiag: "Podłącz kontroler, aby przetestować",
  gamepadDiagButtons: "Przyciski",
  gamepadDiagSticks: "Drążki",
  gamepadDiagTriggers: "Spusty",

  // Audio
  audio: "Dźwięk",
  masterVolume: "Głośność główna",
  musicVolume: "Muzyka",
  sfxVolume: "Efekty dźwiękowe",
  engineVolume: "Silnik",
  voiceVolume: "Głosy",
  ambienceVolume: "Otoczenie",
  mute: "Wycisz",

  backgroundAudio: "Dźwięk w tle",
  // Gameplay
  bonus: "Bonus",
  skiMode: "Tryb zjazdu",
  ski: "Narty",
  snowboard: "Snowboard",
  random: "Losowy",
  skiIt: "Na narty!",
  rideIt: "Na deskę!",
  skiAgain: "Jeszcze raz!",
  rideAgain: "Jeszcze raz!",
  skiRunSpeed: "Prędkość",
  skiRunTime: "Czas",
  skiRunGates: "Bramki",

  // How to Play hints
  howToPlayMove: "{keys} lub strzałki aby się poruszać",
  howToPlayMoveTouch: "Użyj wirtualnego D-pada",
  howToPlayMoveGamepad: "Lewa gałka lub D-pad aby się poruszać",
  howToPlayMoveHybrid: "{keys}/strzałki lub dotykowy D-pad",
  howToPlayGroom: "{groomKey} aby ratrakować śnieg",
  howToPlayGroomTouch: "Przytrzymaj przycisk ratrakowania",
  howToPlayGroomGamepad: "aby ratrakować śnieg",
  howToPlayGroomHybrid: "{groomKey} lub przytrzymaj przycisk ratrakowania",
  howToPlayFuel: "Pilnuj paliwa i kondycji!",
  howToPlayWinch: "{winchKey} przy kotwicy dla wciągarki",
  howToPlayWinchTouch: "Przytrzymaj przycisk wciągarki przy kotwicy",
  howToPlayWinchGamepad: "przy kotwicy dla wciągarki",
  howToPlayWinchHybrid: "{winchKey} lub przytrzymaj przycisk wciągarki przy kotwicy",

  // Winch
  winchSnapped: "💥 Kabel pękł!",
  winchAttached: "🔗 Wciągarka podłączona! Przytrzymaj {winchKey} aby użyć.",
  winchActive: "WCIĄGARKA",
  // UNUSED winchHint: "Naciśnij {winchKey} przy słupku kotwicznym aby użyć wciągarki",
  // UNUSED winchHintTouch: "Przytrzymaj 🔗 aby użyć wciągarki",
  // UNUSED accessPath: "Droga serwisowa",
  // UNUSED toPiste: "Na trasę",

  // Taunts - Cliff falls
  tauntCliff1: "9 ton w przepaść. Ubezpieczyciel będzie zachwycony.",
  tauntCliff2: "Jean-Pierre mówił 'nie za blisko krawędzi!' Pamiętasz?",
  tauntCliff3: "Patrol narciarski zjeżdża z linami. Znowu.",
  tauntCliff4: "Marie anuluje twoją rezerwację na raclette na dzisiejszy wieczór.",
  tauntCliff5: "Thierry już liczy koszty naprawy...",

  // Taunts - Fuel empty
  tauntFuel1: "Wskaźnik był na czerwono 10 minut. Na co patrzyłeś?",
  tauntFuel2: "Émilie napisała 'ZATANKUJ' wielkimi literami na tablicy.",
  tauntFuel3: "Nawet diesel ma swoje granice. Ty najwyraźniej też.",
  tauntFuel4: "Jean-Pierre wzdycha. Wysyła Thierry'ego z kanistrami.",
  tauntFuel5: "Słońce wschodzi. Trasa nie jest przygotowana. Narciarze nadjeżdżają.",

  // Taunts - Time limit
  tauntTime1: "Pierwszy wyciąg za 3... 2... 1... Nie zdążyłeś.",
  tauntTime2: "Narciarze odkrywają twoją trasę. Wyboista. Lodowata. Wspaniała.",
  tauntTime3: "Jean-Pierre patrzy na zegarek, potem na ciebie, potem na zegarek.",
  tauntTime4: "FIS pyta dlaczego slalom jest na brei.",
  tauntTime5: "Słyszysz instruktorów tłumaczących klientom, dlaczego to 'nie ich wina'.",

  // UNUSED paused: "Wstrzymano",
  resume: "Wznów",
  quitToMenu: "Wyjdź do menu",
  levelComplete: "Trasa ukończona!",
  levelFailed: "Trasa nieudana",
  tryAgain: "Spróbuj ponownie",
  coverage: "Pokrycie",
  time: "Czas",
  // UNUSED rating: "Ocena",
  nextLevel: "Następna trasa",
  // UNUSED replay: "Powtórz",
  // UNUSED pressContinue: "Naciśnij spację lub dotknij aby kontynuować",
  pauseTitle: "⏸️ Wstrzymano",
  restart: "Restart",
  skipRun: "Pomiń zjazd",
  newRun: "Nowa trasa",
  quit: "Wyjdź",
  menu: "Menu",
  levelSelect: "Wybór trasy",
  locked: "Zamknięta",
   completeToUnlock: "Ukończ {name}, aby odblokować",
  // UNUSED target: "Cel",
  tutorial: "Szkoła narciarska",
  timeUsed: "Wykorzystany czas",
  excellent: "Doskonale!",
  good: "Dobra robota!",
  passed: "Zaliczono",
  bonusFuel: "Zużycie paliwa",
  bonusFlawless: "Za pierwszym razem",
  bonusSpeed: "Czas",
  bonusWinch: "Użycia wciągarki",
  bonusExplore: "Zbadane drogi",
  bonusPrecision: "Jakość preparacji",
  retry: "Ponów",
  gameComplete: "Gra ukończona!",
  viewCredits: "Zobacz napisy",
  creditsTitle: "Gratulacje!",
  creditsSubtitle: "Opanowałeś Les Aiguilles Blanches",
  creditsCreatedBy: "Stworzył",
  creditsDevelopedWith: "Opracowane z",
  creditsArtDirection: "Kierownictwo artystyczne",
  creditsRetroInspiration: "Ukłon w stronę klasyków retro jak SkiFree",
  creditsInspiredBy: "Inspirowane",
  creditsGroomers: "Ratraczarze z Sabaudii",
  creditsDedication: "Dla nocnych ekip, które przygotowują stoki, gdy śpimy",
  creditsThanks: "Dzięki za grę!",
  creditsSeeYou: "Do zobaczenia na stokach!",
  creditsLine: "Dawaj, chłopcze. Słońce wschodzi. Góra jest gotowa.",
  playAgain: "Graj ponownie",
  skipCredits: "Naciśnij klawisz aby pominąć",

  // Tutorial
  tutorialName: "Samouczek - Pierwsze kroki",
  tutorialTask: "Naucz się podstaw ratrakowania",
  prologueLine: "4 rano. Góra jest twoja. Do roboty.",
  prologueSkip: "Naciśnij, aby kontynuować",
  tutorialIntro: "Witaj w Les Aiguilles Blanches!",
  skipTutorial: "⏭️ Pomijam samouczek… Dotknij aby powtórzyć.",
  skipTutorialGamepad: "⏭️ Pomijam samouczek… Naciśnij przycisk aby powtórzyć.",
  tutorialWelcome: "🏔️ Jean-Pierre, główny ratrakista. Jedź po trasie — użyj {keys} lub ↑↓←→.",
  tutorialWelcomeTouch: "🏔️ Jean-Pierre, główny ratrakista. Jedź po trasie — użyj D-pada po lewej.",
  tutorialWelcomeGamepad: "🏔️ Jean-Pierre, główny ratrakista. Jedź po trasie — użyj lewej gałki lub D-pada.",
  // UNUSED     tutorialControls: "🎮 Aby poruszać ratrakiem, użyj {keys} lub strzałek ↑↓←→.",
  // UNUSED     tutorialControlsTouch: "🎮 Aby poruszać ratrakiem, użyj D-pada ◀▲▼▶ po lewej.",
  // UNUSED     tutorialControlsGamepad: "🎮 Aby poruszać ratrakiem, użyj lewej gałki lub D-pada.",
  // UNUSED     tutorialMove: "➡️ No dalej! Poruszaj się po trasie — cały biały śnieg wymaga ratrakowania.",
  // UNUSED     tutorialGroomIntro: "✅ Ładnie! Teraz nauczmy się ratrakować.",
  tutorialGroomAction: "❄️ Przytrzymaj {groomKey} podczas jazdy aby ratrakować śnieg. Wygładzi się.",
  tutorialGroomActionTouch: "❄️ Przytrzymaj przycisk ratrakowania po prawej podczas jazdy.",
  tutorialGroomActionGamepad: "❄️ Przytrzymaj {groomKey} podczas jazdy aby ratrakować śnieg. Wygładzi się.",
  tutorialGroomGoal: "📊 O to chodzi! Ratrakuj co najmniej 60% przed otwarciem. Narciarze nadjeżdżają!",
  // UNUSED   tutorialCoverage: "📊 Widzisz? Śnieg jest gładszy! Kontynuuj ratrakowanie trasy.",
  // UNUSED   tutorialHUD: "📈 Sprawdź panel na górze: czerwony to paliwo, zielony kondycja, biały pokrycie. Czas leci!",
  // UNUSED   tutorialGoal: "🎯 Musisz ratrakować co najmniej 60% trasy przed otwarciem. Narciarze nadjeżdżają!",
  // UNUSED tutorialFuel: "⛽ Uwaga — jazda zużywa paliwo. Na misjach zatrzymuj się na stacji paliw.",
  tutorialComplete: "🏆 Świetnie! Opanowałeś podstawy. Gotowy na pierwszą misję na zielonej trasie?",

  level_marmottesName: "Zielona trasa - Les Marmottes",
  level_marmottesTask: "Przygotuj trasę dla początkujących",
  level_chamoisName: "Niebieska trasa - Le Chamois",
  level_chamoisTask: "Ratrakuj sprawnie przed otwarciem",
  level_airZoneName: "Snowpark - Air Zone",
  level_airZoneTask: "Przygotuj elementy freestyle",
  level_aigleName: "Czerwona trasa - L'Aigle",
  level_aigleTask: "Ratrakuj stromy teren, pilnuj paliwa",
  level_glacierName: "Czerwona trasa - Le Glacier",
  level_glacierTask: "Naucz się używać wciągarki na stromych stokach",
  level_tubeName: "Half-pipe - Le Tube",
  level_tubeTask: "Utrzymuj half-pipe na zawody",
  level_verticaleName: "Czarna trasa - La Verticale",
  level_verticaleTask: "Nocna operacja z wciągarką",
  level_colDangereuxName: "Strefa lawinowa - Col Dangereux",
  level_colDangereuxTask: "Przygotuj strefę wysokiego ryzyka",
  level_tempeteName: "Burza - Odbudowa",
  level_tempeteTask: "Oczyść trasy po burzy",
  level_coupeDesAiguillesName: "Coupe des Aiguilles - Finał FIS",
  level_coupeDesAiguillesTask: "Przygotuj wszystkie trasy na zawody",

  // Hazards
  cliffFall: "⚠️ UWAGA! Spadłeś z klifu! Misja nieudana.",
  fuelEmpty: "⛽ BRAK PALIWA! Ani kropli diesla...",
  // UNUSED avalancheZone: "STREFA LAWINOWA",
  riskLevelHigh: "WYSOKIE",
  avalancheWarning: "⚠️ NIEBEZPIECZEŃSTWO! Pokrywa śnieżna jest niestabilna! Opuść strefę!",
  avalancheTrigger: "🏔️💨 LAWINA URUCHOMIONA! Nie ma ucieczki!",
  steepWarning: "⚠️ STROMY STOK! Użyj wciągarki ({winchKey}) albo ześlizgniesz się!",
  steepWarningNoWinch: "⚠️ STROMY STOK! Zwolnij i użyj dróg serwisowych, żeby objechać!",
  tumble: "🔄 WYWROTKA! Ratrak wywrócił się na stoku!",

  // Taunts - Tumble
  tauntTumble1: "Wciągarka nie jest ozdobą. Jest na takie stoki.",
  tauntTumble2: "Thierry patrzy na zniszczenia. Nie mówi nic. To gorsze.",
  tauntTumble3: "Jean-Pierre pokazał ci jak kotwić. Spałeś?",
  tauntTumble4: "PistenBully kosztuje 400 000 €. To znaczy kosztował.",
  tauntTumble5: "Stok wydawał się do ogarnięcia? Ratrak się nie zgodził.",
  featureDestroyedKicker: 'Przejechałeś po module parkowym! Kicker jest zniszczony.',
  featureDestroyedRail: 'Przejechałeś po module parkowym! Rail jest zniszczony.',
  tauntFeature1: 'Ten moduł budowali trzy godziny. Zrównałeś go w trzy sekundy.',
  tauntFeature2: 'Émilie będzie miała ci coś do powiedzenia o tym module parkowym.',
  tauntFeature3: 'Ekipa parku właśnie patrzyła, jak niszczysz ich dzieło.',
  tauntFeature4: 'Moduły są dla narciarzy, nie dla ratraków. Objedź je!',
  tauntFeature5: 'Jeden moduł mniej na jutrzejsze zawody.',
  bonusPipeMastery: 'Opanowanie halfpipe\'u',

  // Taunts - Avalanche
  tauntAvalanche1: "Góra rzadko wybacza. Tym razem nie wybaczyła.",
  tauntAvalanche2: "Météo France podało stopień zagrożenia 4. Czytałeś?",
  tauntAvalanche3: "Patrol narciarski znajdzie ratrak wiosną. Może.",
  tauntAvalanche4: "Marie słyszy alarm w radiu. Już wie, że to ty.",
  tauntAvalanche5: "Patrol narciarski zabezpieczył ten sektor. Ty go odbezpieczyłeś.",

  // Taunts - Ski wipeout (fun, self-deprecating)
  tauntSkiWipeout1: "Klasyczny wywrotek. Sprzęt wszędzie, godność nigdzie.",
  tauntSkiWipeout2: "Urwisko nie interesowało się twoją techniką.",
  tauntSkiWipeout3: "Patrol narciarski już się śmieje. Widzieli wszystko.",
  tauntSkiWipeout4: "Tak bywa, gdy jeździ się po własnym stoku.",
  tauntSkiWipeout5: "Nawet kozice skrzywiły się na to lądowanie.",

  jeanPierreIntro: "Dobrze ci poszło na szkoleniu. Teraz jest na poważnie — zielona trasa, z czasem i paliwem do ogarnięcia.",
  level_marmottesMid: "Widzisz ten blask na szczytach? Pierwszy brzask. Najlepsza część tej roboty — tylko ty, maszyna i góra, która się budzi.",
  level_chamoisIntro: "Hej, jestem Émilie — JP wysyła cię na niebieską. Pokaż, że umiesz więcej niż kłaść aksamit na zielonej.",
  level_airZoneIntro: "Snowpark to MOJA działka — przygotujemy im coś szalonego! Każdy moduł musi być idealny, riderzy na nas liczą.",
  level_aigleIntro: "L'Aigle to poważna sprawa. Pilnuj paliwa. Drogi serwisowe pozwalają wrócić — szukaj żółto-czarnych słupków.",
  level_glacierIntro: "Cześć, jestem Thierry — szef bezpieczeństwa. Le Glacier jest stromy. Sprawdziłem każdą kotwę. Naciśnij {winchKey} przy słupku aby podłączyć wciągarkę — i błagam, nie puszczaj.",
  level_glacierIntroTouch: "Cześć, jestem Thierry — szef bezpieczeństwa. Le Glacier jest stromy. Sprawdziłem każdą kotwę. Dotknij przycisku wciągarki przy słupku — i błagam, nie puszczaj.",
  level_tubeIntro: "Jutro contest na Tube! Czyste ściany, ostra krawędź i zero garbów.",
  level_verticaleIntro: "Nocna akcja na La Verticale: strome zbocze, niebezpieczne krawędzie. Wciągarka obowiązkowa — użyj 3 kotwic i trzymaj się osi.",
  level_colDangereuxIntro: "Wysokie ryzyko lawinowe na przełęczy — działamy w protokole bezpieczeństwa lawinowego. Trzymaj się z dala od obciążonych stref i szanuj granice.",
  level_tempeteIntro: "Burza minęła. Weź vin chaud — to potrwa!",
  level_coupeDesAiguillesIntro: "To jest ta wielka noc. FIS kontroluje jutro. Każda trasa musi być idealna — pokaż, czego się nauczyłeś.",
  marieWelcome: "Przyjdź się ogrzać do Chez Marie. Dobra tartiflette!",
  marieIntro: "Cześć! Jestem Marie, prowadzę restaurację na górze trasy. Wpadaj kiedy chcesz — ciepły posiłek czyni cuda!",

  // Changelog
  changelog_20260219_date: "19 lutego 2026",
  changelog_20260219: "🎬 Prolog dla nowych graczy\n📖 Uproszczony samouczek\n🌦️ Losowa pogoda w menu\n🔗 Udostępniane zjazdy dnia\n🎥 Kinowe napisy końcowe",
  changelog_20260222_date: "22 lutego 2026",
  changelog_20260222: "🚩 Rebalans bramek slalomowych\n💬 Przycisk opinii",
  changelog_20260223_date: "23 lutego 2026",
  changelog_20260223: "📲 Zainstaluj na swoim urządzeniu i graj offline",
  changelog_20260220_date: "20 lutego 2026",
  changelog_20260220: "🗺️ Mapa tras\n🎿 Terminologia narciarska",
  changelog_20260217_date: "17 lutego 2026",
  changelog_20260217: "🏔️ Siedem kształtów tras\n🎯 Różnorodność tras\n⚡ Płynniejsza jazda",
  changelog_20260216_date: "16 lutego 2026",
  changelog_20260216: "🎲 Trasy dnia",
  changelog_20260215_date: "15 lutego 2026",
  changelog_20260215: "⚡ Przebudowa nocnego renderingu\n📱 Przyciski dotykowe w trybie ski\n⌨️ Wykrywanie układu klawiatury",
  changelog_20260214_date: "14 lutego 2026",
  changelog_20260214: "🎪 Punktacja trików i combo\n🏂 Pozycja zjazdowa i fizyka halfpipe'u\n👁️ Lepszy kontrast tras\n📱 Automatyczne ratrakowanie na wciągarce (dotyk)\n♿ Tryb wysokiego kontrastu",
  changelog_20260213_date: "13 lutego 2026",
  changelog_20260213: "🚩 Bramki slalomowe\n🏔️ Skoki narciarskie\n⚡ Lepsza wydajność\n🎹 Nokturnowa muzyka fortepianowa\n🔊 Głośność silnika regulowana",
  changelog_20260212_date: "12 lutego 2026",
  changelog_20260212: "📋 Mapa tras\n🔗 Zrywalna lina wciągarki\n🕹️ Diagnostyka kontrolera\n🍽️ Dania Marie\n❄️ Ekspozycja na mróz",
  changelog_20260211_date: "11 lutego 2026",
changelog_20260211: "⛷️ Zjazd na nartach po preparacji\n🎯 Jakość preparacji\n🏔️ Kolorowe strome strefy\n🏗️ Park i triki",
  changelog_20260210_date: "10 lutego 2026",
  changelog_20260210: "🎵 Muzyka i efekty dźwiękowe\n🔈 Ustawienia głośności\n⏱️ Automatycznie kalibrowane czasy\n⏭️ Pomiń samouczek\n🏔️ Przeprojektowane strefy lawinowe",
  changelog_20260209_date: "9 lutego 2026",
  changelog_20260209: "🏔️ Alpejskie ekrany wygranej/przegranej\n❄️ Akumulacja śniegu w burzy\n🏆 Bonus za bezbłędność\n🔊 Dźwięki pogody i przyrody",
  changelog_20260208_date: "8 lutego 2026",
  changelog_20260208: "📊 Przeprojektowany panel\n🏔️ Le Glacier i Coupe des Aiguilles\n🦅 Alpejska przyroda\n🎨 Portrety postaci\n🎮 Nawigacja klawiaturą i gamepadem",
  changelog_20260207_date: "7 lutego 2026",
  changelog_20260207: "🎨 Retro UI\n🎯 Cele bonusowe\n🕹️ Zmiana przycisków gamepada\n🎮 Nawigacja w menu gamepadem",
  changelog_20260206_date: "6 lutego 2026",
  changelog_20260206: "🛤️ Przejezdne drogi serwisowe\n🕹️ Wirtualny joystick\n🌍 5 języków",
  changelog_20260205_date: "5 lutego 2026",
  changelog_20260205: "🏔️ Skaliste klify\n🌙 Nocne reflektory\n🔗 Mechanika wciągarki\n⌨️ Nawigacja klawiaturą",
  changelog_20260204_date: "4 lutego 2026",
  changelog_20260204: "🎮 Obsługa gamepada\n📱 Sterowanie dotykowe\n💪 Kondycja\n💾 Zapis postępu\n♿ Dostępność",
  changelog_20260203_date: "3 lutego 2026",
  changelog_20260203: "🚜 Premiera: 9 tras, szkoła narciarska\n❄️ Ratrakowanie, paliwo, lawiny\n🏆 Napisy i progresja",
  // Key names
  key_space: "SPACJA",
  key_shift: "SHIFT",
  key_ctrl: "CTRL",
  key_alt: "ALT",
  key_enter: "ENTER",
  key_tab: "TAB",
  key_esc: "ESC",
  key_del: "DEL",
  dailyRuns: "Trasy dnia",
  dailyRuns_dailyShift: "Zmiana dzienna",
  dailyRuns_randomRun: "Losowy zjazd",
  dailyRuns_rank: "Ranga",
  dailyRuns_seed: "Ziarno",
  // UNUSED   dailyRuns_start: "Rozpocznij kontrakt",
  dailyRuns_locked: "Ukończ wszystkie trasy, aby odblokować",
  dailyRuns_lockedShared: "Ukończ wszystkie trasy, aby odblokować dzienne biegi i zagrać tę udostępnioną trasę",
  // UNUSED   dailyRun_levelName: "Kontrakt",
  dailyRun_levelTask: "Przygotuj trasę do docelowego pokrycia",
  dailyRuns_briefing: "Odprawа",
  dailyRuns_target: "Cel",
  dailyRuns_timeLimit: "Czas",
  dailyRuns_weather_clear: "Bezchmurne niebo",
  dailyRuns_weather_light_snow: "Lekkie opady śniegu",
  dailyRuns_weather_storm: "Warunki burzowe",
  dailyRuns_night: "Zmiana nocna",
  dailyRuns_day: "Zmiana dzienna",
  rank_green: "Zielony",
  rank_blue: "Niebieski",
  rank_red: "Czerwony",
  rank_black: "Czarny",
  rank_park: "Park",
  share: "Udostępnij",
  copied: "Link skopiowany!",
  playSharedSeed: "Udostępniony bieg",
  dailyRunBriefingJP: "Trasa musi być gotowa przed otwarciem wyciągów. Do roboty.",
  dailyRunBriefingThierry: "Uważaj tam — strome odcinki i niestabilny śnieg. Bądź czujny.",
  dailyRunBriefingMarie: "Dziś w nocy będzie porządny mróz. Wpadnij do restauracji się rozgrzać, jak będziesz potrzebować.",
  dailyRunBriefingEmilie: "Kolejna trasa do przygotowania. Spróbuj pobić mój czas!"
};

export default pl;
